import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { getPaymentStatus } from "../lib/api";
import { useStore } from "../context/StoreContext";
import { CheckCircle2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clearCart } = useStore();
  const [status, setStatus] = useState("checking");
  const [amount, setAmount] = useState(null);
  const cleared = useRef(false);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const res = await getPaymentStatus(sessionId);
        if (res.payment_status === "paid") {
          setStatus("paid"); setAmount(res.amount);
          if (!cleared.current) { clearCart(); cleared.current = true; }
          return;
        }
        if (res.status === "expired" || attempts > 8) { setStatus("error"); return; }
      } catch { if (attempts > 8) { setStatus("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="container-luxe py-32 text-center max-w-lg mx-auto" data-testid="payment-success-page">
      {status === "checking" && <p className="font-serif text-3xl">Confirming your payment…</p>}
      {status === "paid" && (
        <>
          <CheckCircle2 size={56} strokeWidth={1} className="text-gold mx-auto mb-8" />
          <h1 className="h-display text-5xl mb-4">Thank You ✦</h1>
          <p className="text-sm text-muted-foreground font-light mb-2">Your order is confirmed{amount ? ` — $${amount.toFixed(2)}` : ""}.</p>
          <p className="text-sm text-muted-foreground font-light mb-10">A confirmation and tracking details are on their way to your inbox.</p>
          <div className="flex gap-4 justify-center">
            <Link to="/account" className="btn-primary" data-testid="view-orders-btn">View Orders</Link>
            <Link to="/shop" className="btn-secondary">Continue Shopping</Link>
          </div>
        </>
      )}
      {status === "error" && (
        <>
          <XCircle size={56} strokeWidth={1} className="text-destructive mx-auto mb-8" />
          <h1 className="h-display text-5xl mb-4">Something Went Wrong</h1>
          <p className="text-sm text-muted-foreground font-light mb-10">We couldn't confirm your payment. If you were charged, contact our care team.</p>
          <Link to="/cart" className="btn-primary">Return To Bag</Link>
        </>
      )}
    </div>
  );
}
